import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiEndPoint, StatusCode } from "../../services/helper";
import API from "../../services/api";
import { toast } from "react-toastify";
const initialState = {
  UserManagementData: [],
  status: StatusCode.IDLE,
};
const {
  USERMANAGEMENT,
  USERMANAGEMENTDATABYID,
  UPDATEUSERMANAGEMENTDATA,
  DELETEUSERMANAGEMENTDATA,
  CREATENEWUSER,
} = ApiEndPoint;
export const UserManagementSlice = createSlice({
  name: "usermanagement",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserManagementData.pending, (state, action) => {
        state.status = StatusCode.LOADING;
      })
      .addCase(fetchUserManagementData.fulfilled, (state, action) => {
        state.UserManagementData = action.payload;
        state.status = StatusCode.IDLE;
      })
      .addCase(fetchUserManagementData.rejected, (state, action) => {
        state.status = StatusCode.ERROR;
      })
      // GET USER BY ID
      .addCase(fetchUserManagementDataById.pending, (state, action) => {
        state.status = StatusCode.LOADING;
      })
      .addCase(fetchUserManagementDataById.fulfilled, (state, action) => {
        state.UserManagementData = action?.payload?.data?.user_details;
        state.status = StatusCode.IDLE;
      })
      .addCase(fetchUserManagementDataById.rejected, (state, action) => {
        state.status = StatusCode.ERROR;
      })
      //  case for create user
      .addCase(createNewUser.pending, (state) => {
        state.status = StatusCode.LOADING;
      })
      .addCase(createNewUser.fulfilled, (state) => {
        state.status = StatusCode.IDLE;
      })
      .addCase(createNewUser.rejected, (state) => {
        state.status = StatusCode.ERROR;
      })
      // UPDATE USER
      .addCase(updateUserManagementData.pending, (state, action) => {
        state.status = StatusCode.LOADING;
      })
      .addCase(updateUserManagementData.fulfilled, (state, action) => {
        state.UserManagementData = action.payload;
        state.status = StatusCode.IDLE;
      })
      .addCase(updateUserManagementData.rejected, (state, action) => {
        state.status = StatusCode.ERROR;
      });
  },
});

export const {} = UserManagementSlice.actions;
export default UserManagementSlice.reducer;

export const fetchUserManagementData = createAsyncThunk(
  "admin/get/users",
  async () => {
    try {
      const res = await API.get(USERMANAGEMENT);
      if (res.data?.status === 200) {
        return res.data?.data?.Users;
      }
    } catch (error) {
      console.error("Failed to fetch User management data:", error);
      throw error;
    }
  }
);

export const fetchUserManagementDataById = createAsyncThunk(
  "admin/get/user",
  async (id) => {
    try {
      const res = await API.get(`${USERMANAGEMENTDATABYID}/${id}`);
      return res.data;
    } catch (error) {
      console.error("Failed to fetch User management data:", error);
      throw error;
    }
  }
);

// export const updateUserManagementData = createAsyncThunk(
//   "admin/update/user",
//   async ({ values, id }) => {
//     try {
//       const res = await API.put(`${UPDATEUSERMANAGEMENTDATA}/${id}`, values, {
//         headers: {
//           "Content-Type": "multipart/form-data",
//         },
//       });
//     } catch (error) {
//       toast.error(error.data?.message);
//       throw error;
//     }
//   }
// );
export const updateUserManagementData = createAsyncThunk(
  "admin/update/user",
  async ({ values, id }) => {
    try {
      const res = await API.put(`${UPDATEUSERMANAGEMENTDATA}/${id}`, values, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      // Return the response data
      toast.success(res.data?.message);
      return res.data;
    } catch (error) {
      toast.error(error.data?.message);
      throw error;
    }
  }
);

export const deleteUserManagementData = createAsyncThunk(
  "admin/delete/user",
  async (data) => {
    try {
      const res = await API.delete(`${DELETEUSERMANAGEMENTDATA}`, {
        data: data,
      });
      if (res.status === 200) {
        toast.success(res?.data?.message);
        return res?.data;
      }
    } catch (error) {
      toast.error(error.data?.message);
      throw error;
    }
  }
);

export const createNewUser = createAsyncThunk(
  "create/new/user",
  async (data) => {
    try {
      const res = await API.post(`${CREATENEWUSER}`, data.payload, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (res.status === 200) {
        toast.success(res.data?.message);
      }
      return res.data;
    } catch (error) {
      if (error.data.status === 401) {
        // console.log("errpor catch")
        data?.cb();
      } else {
        toast.error(error?.data?.message);
      }
    }
  }
);
